import React, { useRef, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export const MagneticButton = ({ children, strength = 0.3, className }) => {
    const ref = useRef(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const prefersReducedMotion = useReducedMotion();
    const isTouch = typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;

    const handleMouse = (e) => {
        if (isTouch || prefersReducedMotion) return;
        if (!ref.current) return;
        const { clientX, clientY } = e;
        const { height, width, left, top } = ref.current.getBoundingClientRect();
        const middleX = clientX - (left + width / 2);
        const middleY = clientY - (top + height / 2);
        const max = 8;
        setPosition({
            x: Math.max(-max, Math.min(max, middleX * strength)),
            y: Math.max(-max, Math.min(max, middleY * strength))
        });
    };

    const reset = () => {
        setPosition({ x: 0, y: 0 });
    };

    return (
        <motion.div
            ref={ref}
            onMouseMove={handleMouse}
            onMouseLeave={reset}
            animate={{ x: position.x, y: position.y }}
            transition={{ type: 'spring', stiffness: 150, damping: 15, mass: 0.1 }}
            className={className}
            style={{ willChange: 'transform' }}
        >
            {children}
        </motion.div>
    );
};

export default MagneticButton;